import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const TeamMember = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Link
                className="col-8 col-md-4 col-lg-3 text-decoration-none text-white text-center px-0 mx-md-4 mx-1 r-t border-1 border border-white"
                to={props.Link}
                id="website-responsive"
                target="_blank"
            >
                <img
                    src={props.ProfileImg}
                    alt=""
                    className="w-100 px-0"
                    style={{ height: '300px', objectFit: 'cover', objectPosition: 'top center' }}
                />
                <div className="fs-ss-16 fw-400 lh-base py-4">
                    <div className="fw-500 fs-ss-24 lh-sm text-white pb-2"> {props.Title1} </div>
                    <div className="fw-400 fs-ss-16 text-ss-primary"> {props.Title2} </div>
                </div>
            </Link>
        </>
    )
}

export default TeamMember
